import { action } from 'typesafe-actions';
import type { OfficeUser, UserOffice } from '../../lib/api/prime/prime';
import type { ITemplate } from '../templateCreate/template-types';
import type { IShareRecord, ITemplateUser, SubGroup } from './types';

export enum ActionTypes {
  RESET = 'templateSharing/RESET',
  FETCH_USERS = 'templateSharing/FETCH_USERS',
  FETCH_USERS_DONE = 'templateSharing/FETCH_USERS_DONE',
  FETCH_USERS_GROUPS_DONE = 'templateSharing/FETCH_USERS_GROUPS_DONE',
  FETCH_USERS_ERROR = 'templateSharing/FETCH_USERS_ERROR',
  TOGGLE_TEMPLATE_SHARE_TO_USER = 'templateSharing/TOGGLE_TEMPLATE_SHARE_TO_USER',
  TOGGLE_TEMPLATE_SHARE_TO_USER_DONE = 'templateSharing/TOGGLE_TEMPLATE_SHARE_TO_USER_DONE',
  TOGGLE_TEMPLATE_SHARE_TO_USER_ERROR = 'templateSharing/TOGGLE_TEMPLATE_SHARE_TO_USER_ERROR',
  TOGGLE_TEMPLATE_SHARE_TO_SUB_GROUP = 'templateSharing/TOGGLE_TEMPLATE_SHARE_TO_SUB_GROUP',
  TOGGLE_TEMPLATE_SHARE_TO_SUB_GROUP_DONE = 'templateSharing/TOGGLE_TEMPLATE_SHARE_TO_SUB_GROUP_DONE',
  TOGGLE_TEMPLATE_SHARE_TO_ALL_PARENT_GROUPS = 'templateSharing/TOGGLE_TEMPLATE_SHARE_TO_ALL_PARENT_GROUPS',
  TOGGLE_TEMPLATE_SHARE_TO_ALL_PARENT_GROUPS_DONE = 'templateSharing/TOGGLE_TEMPLATE_SHARE_TO_ALL_PARENT_GROUPS_DONE',
  FETCH_TEMPLATE_SHARE_INFORMATION = 'templatesharing/FETCH_TEMPLATE_SHARE_INFORMATION',
  FETCH_TEMPLATE_SHARE_INFORMATION_DONE = 'templateSharing/FETCH_TEMPLATE_SHARE_INFORMATION_DONE',
  TOGGLE_GROUPS_SORT = 'templateSharing/TOGGLE_GROUPS_SORT',
  TOGGLE_OFFICE_SORT = 'templateSharing/TOGGLE_OFFICE_SORT',
  FETCH_TEMPLATE_SHARE_OFFICES = 'templateSharing/FETCH_TEMPLATE_SHARE_OFFICES',
  FETCH_TEMPLATE_SHARE_OFFICES_DONE = 'templateSharing/FETCH_TEMPLATE_SHARE_OFFICES_DONE',
  TOGGLE_TEMPLATE_SHARE_TO_OFFICE = 'templateSharing/TOGGLE_TEMPLATE_SHARE_TO_OFFICE',
  TOGGLE_TEMPLATE_SHARE_TO_OFFICE_DONE = 'templateSharing/TOGGLE_TEMPLATE_SHARE_TO_OFFICE_DONE',
  FETCHING_OFFICE_USERS = 'templateSharing/FETCHING_OFFICE_USERS',
  FETCH_OFFICE_USERS = 'templateSharing/FETCH_OFFICE_USERS',
  FETCH_OFFICE_USERS_DONE = ' templateSharing/FETCH_OFFICE_USERS_DONE',
  UPDATE_USERS = 'templateSharing/UPDATE_USERS',
}

// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
export const reset = () => action(ActionTypes.RESET, {});
// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
export const fetchUsers = (limit: number, skip: number, search: string, fromScroll?: boolean) =>
  action(ActionTypes.FETCH_USERS, { limit, skip, search, fromScroll });
// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
export const fetchUsersDone = (
  users: ITemplateUser[],
  fromSearch?: boolean,
  totalCount?: number,
  search?: string,
  fromScroll?: boolean
) => action(ActionTypes.FETCH_USERS_DONE, { users, fromSearch, totalCount, search, fromScroll });
// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
export const fetchUsersGroupsDone = (
  sharedToAllParentGroups: boolean,
  parentGroups: string[],
  subGroups: SubGroup[],
  error?: boolean
) => action(ActionTypes.FETCH_USERS_GROUPS_DONE, { sharedToAllParentGroups, parentGroups, subGroups, error });
// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
export const fetchUsersError = (error: string) => action(ActionTypes.FETCH_USERS_ERROR, { error });
// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
export const toggleTemplateShareToUser = (
  user: ITemplateUser,
  templateName: string,
  templateId: string,
  sharedToAllParentGroups: boolean,
  sharedToASubGroup: boolean,
  sharedToAnOffice: boolean
) =>
  action(ActionTypes.TOGGLE_TEMPLATE_SHARE_TO_USER, {
    user,
    templateName,
    templateId,
    sharedToAllParentGroups,
    sharedToASubGroup,
    sharedToAnOffice,
  });
// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
export const toggleTemplateShareToUserDone = (
  user: ITemplateUser,
  sharedToAllParentGroups: boolean,
  sharedToASubGroup: boolean,
  error?: boolean
) =>
  action(ActionTypes.TOGGLE_TEMPLATE_SHARE_TO_USER_DONE, { user, sharedToAllParentGroups, sharedToASubGroup, error });
// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
export const toggleTemplateShareToSubGroup = (
  template: ITemplate,
  group: SubGroup,
  alreadyShared: boolean,
  sharedToAllParentGroups: boolean,
  subGroups: SubGroup[],
  sharedIds: IShareRecord[]
) =>
  action(ActionTypes.TOGGLE_TEMPLATE_SHARE_TO_SUB_GROUP, {
    template,
    group,
    alreadyShared,
    sharedToAllParentGroups,
    subGroups,
    sharedIds,
  });
// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
export const toggleTemplateShareToSubGroupDone = (
  groupId: string,
  sharedToAllParentGroups: boolean,
  error: boolean,
  usersSharedByOffice?: { oktaUserID: string }[]
) =>
  action(ActionTypes.TOGGLE_TEMPLATE_SHARE_TO_SUB_GROUP_DONE, {
    groupId,
    sharedToAllParentGroups,
    error,
    usersSharedByOffice,
  });
// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
export const toggleTemplateShareToAllUsersGroups = (
  alreadyShared: boolean,
  templateId: string,
  officeSharingEnabled: boolean,
  offices: UserOffice[]
) =>
  action(ActionTypes.TOGGLE_TEMPLATE_SHARE_TO_ALL_PARENT_GROUPS, {
    alreadyShared,
    templateId,
    officeSharingEnabled,
    offices,
  });
// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
export const toggleShareTemplateToAllUsersGroupsDone = (alreadyShared: boolean, error?: boolean) =>
  action(ActionTypes.TOGGLE_TEMPLATE_SHARE_TO_ALL_PARENT_GROUPS_DONE, { alreadyShared, error });
// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
export const fetchTemplateShareInformation = (
  limit: number,
  skip: number,
  search: string,
  templateId: string,
  oktaUserId: string,
  fetchOffices: boolean
) =>
  action(ActionTypes.FETCH_TEMPLATE_SHARE_INFORMATION, {
    limit,
    skip,
    search,
    templateId,
    oktaUserId,
    fetchOffices,
  });
// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
export const fetchTemplateShareInformationDone = (
  users: ITemplateUser[],
  totalUsers: number,
  shares: IShareRecord[],
  userExclusions: string[],
  offices: UserOffice[],
  usersFromOffices: OfficeUser[]
) =>
  action(ActionTypes.FETCH_TEMPLATE_SHARE_INFORMATION_DONE, {
    users,
    totalUsers,
    shares,
    userExclusions,
    offices,
    usersFromOffices,
  });
// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
export const toggleGroupsSort = () => action(ActionTypes.TOGGLE_GROUPS_SORT);
// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
export const toggleOfficesSort = () => action(ActionTypes.TOGGLE_OFFICE_SORT);

// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
export const fetchTemplateShareOffices = () => action(ActionTypes.FETCH_TEMPLATE_SHARE_OFFICES);
// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
export const fetchTemplateShareOfficesDone = (offices: UserOffice[]) =>
  action(ActionTypes.FETCH_TEMPLATE_SHARE_OFFICES_DONE, { offices });
// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
export const toggleTemplateShareToOffice = (
  officeGuid: string,
  officeName: string,
  templateId: string,
  templateName: string,
  alreadyShared: boolean,
  sharedIds: IShareRecord[]
) => {
  return action(ActionTypes.TOGGLE_TEMPLATE_SHARE_TO_OFFICE, {
    officeGuid,
    officeName,
    templateId,
    templateName,
    alreadyShared,
    sharedIds,
  });
};
// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
export const toggleTemplateShareToOfficeDone = (
  alreadyShared: boolean,
  officeGuid: string,
  usersInOffice: OfficeUser[],
  isAllOffice: boolean
) =>
  action(ActionTypes.TOGGLE_TEMPLATE_SHARE_TO_OFFICE_DONE, { alreadyShared, officeGuid, usersInOffice, isAllOffice });
// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
export const fetchingOfficeUsers = () => action(ActionTypes.FETCHING_OFFICE_USERS);
// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
export const fetchOfficeUsers = (officeGuids: string[]) => action(ActionTypes.FETCH_OFFICE_USERS, { officeGuids });
// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
export const fetchOfficeUsersDone = (officeUsers: OfficeUser[]) =>
  action(ActionTypes.FETCH_OFFICE_USERS_DONE, { officeUsers });
// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
export const updateUsers = (users: ITemplateUser[]) => action(ActionTypes.UPDATE_USERS, { users });
